import React, { useState, useEffect } from 'react';
import { useApi } from '@/hooks/useApi';
import { createAccountService } from "../services/apiService";

import { Layout } from "@/components/Layout"
import { Toaster } from "@/components/ui/toaster"
import { TrialAccountsPane } from "@/components/TrialAccountsPane";

interface Account {
    storeUrl: string;
    expiresAt: string;
    hooksCount: number;
    usage: number;
}

export const ActiveTrials: React.FC = () => {
    const api = useApi();
    const accountService = createAccountService(api);
    const [accounts, setAccounts] = useState<Account[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [activeMenuItem, setActiveMenuItem] = useState("active-trials")

    useEffect(() => {
        const fetchActiveTrials = async () => {
            try {
                setLoading(true);
                const response = await accountService.getActiveTrials();
                if (response.data.success) {
                    setAccounts(response.data.accounts);
                } else {
                    setError('Failed to fetch accounts.');
                }
            } catch (err) {
                console.error('Error fetching accounts:', err);
                setError('Error fetching accounts. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchActiveTrials();
    }, []);

    return (
        <Layout activeMenuItem={activeMenuItem} >
            <div className="space-y-6">
                <div className="border rounded-md">
                    {loading ? (
                        <div className="p-4 text-center">Loading trial accounts...</div>
                    ) : error ? (
                        <div className="p-4 text-center text-red-500">{error}</div>
                    ) : accounts.length === 0 ? (
                        <div className="p-4 text-center">No active trial accounts found.</div>
                    ) : (
                        <TrialAccountsPane accounts={accounts} />
                    )}
                </div>
            </div>
            <Toaster />
        </Layout>
    )
};
